import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import styles from "./E3Image.module.css";
import { isEmpty } from "lodash";
import { getChildrenCommonCode } from "e3-common/utils/commonCodeUtil";
import useFetch from "e3-common/hooks/useFetch";
import { enable } from "@grapecity/wijmo";

/**
 * E3Image
 * @type React.FC<E3ImagePropTypes>
 */
const E3Image = React.forwardRef(
  (
    {
      src,
      srcDefault = "../css/images/icon_man.png",
      width = 100,
      height = 100,
      ...props
    },
    ref
  ) => {
    const [imageSrc, setImageSrc] = useState(src || srcDefault);

    const content = imageSrc || src || srcDefault;
    React.useImperativeHandle(ref, () => ({
      getValue() {
        return imageSrc;
      },

      setValue: (value) => {
        setImageSrc(value);
      },

      clear() {
        setImageSrc("");
      },
      enable() {},
    }));

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <img src={content} width={width} height={height} {...props}></img>
      </div>
    );
  }
);

E3Image.displayName = "E3Image";
export default E3Image;
